// En-tête (composant Header) : sous-menu desktop, burger en barre compacte (< 1030px), ombre au défilement.
// Fermeture au clic extérieur et à Échap, focus rendu au déclencheur.
(function(document, window) {
    document.addEventListener("DOMContentLoaded", function() {
        const   header = document.querySelector('#header-navigation'),
                burger = header && header.querySelector('.site-header__burger'),
                mobile = window.matchMedia('(max-width: 1029px)') // barre compacte : mobile et tablette
        ;

        if(!header) return;

        const menus = header.querySelectorAll('.site-nav__menu');

        // Ombre sous la barre dès que la page défile
        function handleScroll() {
            header.classList.toggle('is-scrolled', window.scrollY > 0);
        }

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });

        function closeMenus(except) {
            menus.forEach((menu) => {
                if(menu !== except && menu.open) {
                    menu.open = false;
                }
            });
        }

        function setMenuOpen(open) {
            header.classList.toggle('is-menu-open', open);
            document.body.classList.toggle('has-menu-open', open);
            burger.setAttribute('aria-expanded', open);
            burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
            // En barre compacte, le sous-menu est un accordéon ouvert par défaut
            menus.forEach((menu) => { menu.open = open; });
        }

        // Desktop : un seul sous-menu ouvert à la fois
        menus.forEach((menu) => {
            menu.addEventListener('toggle', () => {
                if(menu.open && !mobile.matches) closeMenus(menu);
            });
        });

        document.addEventListener('click', (e) => {
            if(mobile.matches) return;
            closeMenus(e.target.closest('.site-nav__menu'));
        });

        document.addEventListener('keydown', (e) => {
            if(e.key !== 'Escape') return;

            if(header.classList.contains('is-menu-open')) {
                setMenuOpen(false);
                burger.focus();
                return;
            }

            const openMenu = header.querySelector('.site-nav__menu[open]');
            if(openMenu) {
                openMenu.open = false;
                openMenu.querySelector('summary').focus();
            }
        });

        if(burger) {
            burger.addEventListener('click', () => {
                setMenuOpen(!header.classList.contains('is-menu-open'));
            });

            // Retour en desktop menu ouvert : on referme pour ne pas laisser la page figée
            mobile.addEventListener('change', (e) => {
                if(!e.matches && header.classList.contains('is-menu-open')) setMenuOpen(false);
            });
        }
    });
})(document, window);
